export default {
  Email: 'geral@raparigasdocodigo.pt',
  Kofi: 'https://ko-fi.com/asraparigasdocodigo'
};
